(function () {
  'use strict';
  if (window.LuxsterVehicle || !window.LuxsterVehicleBoot) return;
  var boot = window.LuxsterVehicleBoot;

  var DATA_URL = 'https://cdn.shopify.com/s/files/1/0741/4897/0789/files/0326.json?v=1742983080';
  var STORAGE_KEY = 'luxster:vehicle-garage';
  var VERSION = 1;
  var fields = ['year', 'make', 'model', 'position'];
  var columns = { year: 'Year', make: 'Make', model: 'Model', position: 'Position' };
  var rows = [];
  var listeners = new Set();
  var selection = emptySelection();
  var vehicles = [];
  var activeId = null;
  var loaded = false;
  var loading = false;
  var error = '';
  var submitting = false;
  var submitPromise = null;
  var dataPromise;
  var dataRequest = null;
  var dataVersion = 0;
  var optionCache = {};
  var pendingResultContext = false;
  var resultContext = '';
  var stateRevision = 0;
  var formMessages = new WeakMap();

  function emptySelection() { return { year: '', make: '', model: '', position: '' }; }
  function text(value) { return value == null ? '' : String(value); }
  function messageText(key) {
    var form = document.querySelector('[data-vehicle-form]');
    return form ? form.dataset[key] || '' : '';
  }
  function copySelection(value) {
    return boot.copySelection(value);
  }
  function vehicleKey(value) { return JSON.stringify([value.year, value.make, value.model]); }
  function positionLabel(row) { return row.Position || row.Note ? row.Position + ' ' + row.Note : ''; }
  function prefixMatches(row, value, count) {
    return fields.slice(0, count).every(function (field) { return row[columns[field]] === value[field]; });
  }
  function unique(values) { return Array.from(new Set(values.filter(Boolean))).sort(); }
  function optionsFor(field, value) {
    if (!loaded) return [];
    var index = fields.indexOf(field);
    if (index < 0 || fields.slice(0, index).some(function (key) { return !value[key]; })) return [];
    var candidates = index ? rows.filter(function (row) { return prefixMatches(row, value, index); }) : rows;
    var options = unique(candidates.map(function (row) { return field === 'position' ? positionLabel(row) : row[columns[field]]; }));
    if (field === 'year') options.sort(function (a, b) { return Number(b) - Number(a) || b.localeCompare(a); });
    return options;
  }
  function invalidateOptions() { optionCache = {}; }
  function getOptions(field) {
    if (!Object.prototype.hasOwnProperty.call(optionCache, field)) optionCache[field] = optionsFor(field, selection);
    return optionCache[field].slice();
  }
  function normalizeSelection(value, allowPositionPrefix) {
    var next = copySelection(value);
    fields.forEach(function (field, index) {
      if (index && !next[fields[index - 1]]) next[field] = '';
      if (!next[field]) return;
      var options = optionsFor(field, next);
      if (options.indexOf(next[field]) !== -1) return;
      if (field === 'position' && allowPositionPrefix) {
        var matches = options.filter(function (option) { return option.indexOf(next[field]) === 0; });
        if (matches.length === 1) { next[field] = matches[0]; return; }
      }
      next[field] = '';
    });
    return next;
  }
  function normalizeResultSelection(value) {
    var next = normalizeSelection(value, true);
    if (!next.year || !next.make || !next.model) return emptySelection();
    if (fields.slice(0, 3).some(function (field) { return next[field] !== value[field]; })) return emptySelection();
    // The result URL abbreviates Position. Resolve only a unique data option;
    // an unknown or ambiguous position must never broaden to the whole model.
    if (value.position && !next.position) return emptySelection();
    if (optionsFor('position', next).length && !next.position) return emptySelection();
    return next;
  }
  function parseResultSelection(context) {
    return boot.parseContext(context);
  }
  function currentResultContext() {
    return boot.currentContext();
  }
  function applyResultContext(context) {
    selection = parseResultSelection(context);
    var saved = boot.matchSaved(selection, vehicles, true);
    if (saved) selection = copySelection(saved);
    activeId = saved ? saved.id : null;
    pendingResultContext = true;
    resultContext = typeof context === 'string' ? context : '';
    invalidateOptions();
  }
  function syncResultContext(context, expectedRevision) {
    if (boot.isBulbContext(context)) return getState();
    if (expectedRevision != null && expectedRevision !== stateRevision) return getState();
    ++stateRevision;
    applyResultContext(context);
    if (loaded) {
      selection = normalizeResultSelection(selection);
      pendingResultContext = false;
      upsertVehicle();
    }
    persist();
    formMessages = new WeakMap();
    emit();
    return getState();
  }
  function needsPosition() { return !selection.model || getOptions('position').length > 0; }
  function isComplete() { return loaded && Boolean(selection.year && selection.make && selection.model && (!needsPosition() || selection.position)); }
  function upsertVehicle() {
    var matched = boot.matchSaved(selection, vehicles, false);
    activeId = matched ? matched.id : null;
    if (!isComplete()) return;
    var key = vehicleKey(selection);
    var saved = vehicles.find(function (vehicle) { return vehicleKey(vehicle) === key; });
    if (!saved) {
      saved = { id: 'vehicle-' + encodeURIComponent(key) };
      vehicles.push(saved);
    }
    if (saved.position !== selection.position) delete saved.resultContext;
    fields.forEach(function (field) { saved[field] = selection[field]; });
    if (contextMatchesSelection(resultContext, selection, true)) saved.resultContext = canonicalContext(resultContext, selection);
    activeId = saved.id;
  }
  function getState() {
    return {
      selection: copySelection(selection), ready: loaded, loading: loading, error: error,
      complete: isComplete(), needsPosition: needsPosition(), submitting: submitting,
      vehicles: vehicles.map(function (vehicle) { return Object.assign({ id: vehicle.id }, copySelection(vehicle)); }),
      activeId: activeId, revision: stateRevision
    };
  }
  function persist() {
    syncBoot();
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({ version: VERSION, selection: selection, vehicles: vehicles, activeId: activeId }));
    } catch (storageError) { /* The current page still shares state when storage is unavailable. */ }
  }
  function readStored(raw) {
    var stored = boot.readStored(raw);
    if (!stored) return false;
    selection = stored.selection;
    vehicles = stored.vehicles;
    activeId = stored.activeId;
    pendingResultContext = false;
    resultContext = '';
    invalidateOptions();
    return true;
  }
  function restore() {
    selection = copySelection(boot.state.selection);
    vehicles = boot.state.vehicles;
    activeId = boot.state.activeId;
    pendingResultContext = boot.state.pendingResultContext;
    resultContext = boot.state.resultContext || '';
  }
  function syncBoot() {
    boot.state = { selection: copySelection(selection), vehicles: vehicles, activeId: activeId,
      pendingResultContext: pendingResultContext, resultContext: resultContext };
  }
  function contextMatchesSelection(context, value, allowLegacyPrefix) {
    var parsed = parseResultSelection(context);
    if (!parsed.year || !fields.slice(0, 3).every(function (field) { return parsed[field] === value[field]; })) return false;
    if (!context.split('@@')[1].split(',').some(function (part) { return part.trim(); })) return false;
    if (parsed.position === value.position) return true;
    if (!allowLegacyPrefix || !loaded || !parsed.position) return false;
    var matches = optionsFor('position', parsed).filter(function (position) { return position.indexOf(parsed.position) === 0; });
    return matches.length === 1 && matches[0] === value.position;
  }
  function canonicalContext(context, value) {
    return [value.year, value.make, value.model].join('@') + (value.position ? '@' + value.position : '') + '@@' + context.split('@@')[1];
  }

  function renderForms() {
    var state = getState();
    document.querySelectorAll('[data-vehicle-form]').forEach(function (form) {
      form.setAttribute('aria-busy', String(loading || submitting));
      form.querySelectorAll('[data-vehicle-field]').forEach(function (control) {
        var field = control.dataset.vehicleField;
        var index = fields.indexOf(field);
        if (index === -1) return;
        var options = getOptions(field);
        var signature = JSON.stringify(options);
        if (control.dataset.vehicleOptions !== signature) {
          var placeholder = control.dataset.placeholder || (control.options[0] && control.options[0].textContent) || '';
          control.dataset.placeholder = placeholder;
          var fragment = document.createDocumentFragment();
          var first = document.createElement('option');
          first.value = '';
          first.textContent = placeholder;
          fragment.appendChild(first);
          options.forEach(function (value) {
            var option = document.createElement('option');
            option.value = value;
            option.textContent = value;
            fragment.appendChild(option);
          });
          control.replaceChildren(fragment);
          control.dataset.vehicleOptions = signature;
        }
        control.value = selection[field];
        control.disabled = !loaded || submitting || fields.slice(0, index).some(function (key) { return !selection[key]; });
        control.required = field !== 'position' || state.needsPosition;
      });
      form.querySelectorAll('[data-vehicle-position]').forEach(function (region) { region.hidden = !state.needsPosition; });
      form.querySelectorAll('[data-vehicle-submit]').forEach(function (button) { button.disabled = !state.complete || submitting; });
      var message = loading ? form.dataset.loadingText || '' : error ? form.dataset.errorText || '' : formMessages.get(form) || '';
      form.querySelectorAll('[data-vehicle-status]').forEach(function (status) { status.textContent = message; status.hidden = !message; });
      form.querySelectorAll('[data-vehicle-retry]').forEach(function (button) { button.hidden = !error; button.disabled = loading; });
    });
  }
  function emit() {
    syncBoot();
    renderForms();
    listeners.forEach(function (listener) { listener(getState()); });
  }
  function commit() {
    ++stateRevision;
    pendingResultContext = false;
    resultContext = '';
    invalidateOptions(); upsertVehicle(); persist(); formMessages = new WeakMap(); emit();
  }
  function select(field, value) {
    if (!loaded || submitting || fields.indexOf(field) === -1) return false;
    value = text(value);
    if (value && getOptions(field).indexOf(value) === -1) return false;
    if (selection[field] === value) return true;
    selection[field] = value;
    fields.slice(fields.indexOf(field) + 1).forEach(function (key) { selection[key] = ''; });
    commit();
    return true;
  }
  function activate(id) {
    if (submitting) return false;
    var vehicle = vehicles.find(function (item) { return item.id === id; });
    if (!vehicle) return false;
    selection = loaded ? normalizeSelection(vehicle) : copySelection(vehicle);
    commit();
    return true;
  }
  function add() {
    if (submitting) return;
    selection = emptySelection();
    commit();
  }
  function remove(id) {
    if (submitting) return;
    var wasActive = id === activeId;
    vehicles = vehicles.filter(function (vehicle) { return vehicle.id !== id; });
    if (wasActive) selection = vehicles.length ? copySelection(vehicles[0]) : emptySelection();
    commit();
  }
  function clear() {
    if (submitting) return;
    vehicles = [];
    selection = emptySelection();
    commit();
  }
  function validateRestoredState() {
    vehicles = vehicles.map(function (vehicle) {
      var validated = normalizeSelection(vehicle);
      var hasPosition = optionsFor('position', validated).length > 0;
      return validated.year && validated.make && validated.model && (!hasPosition || validated.position)
        ? Object.assign({ id: vehicle.id, resultContext: contextMatchesSelection(vehicle.resultContext, validated, true) ? canonicalContext(vehicle.resultContext, validated) : undefined }, validated) : null;
    }).filter(Boolean);
    selection = pendingResultContext ? normalizeResultSelection(selection) : normalizeSelection(selection);
    pendingResultContext = false;
    invalidateOptions();
    upsertVehicle();
  }
  function loadData() {
    var version = ++dataVersion;
    if (dataRequest) dataRequest.abort();
    var controller = new AbortController();
    dataRequest = controller;
    loading = true;
    error = '';
    emit();
    var timeout = setTimeout(function () { controller.abort(); }, 25000);
    return fetch(DATA_URL, { signal: controller.signal }).then(function (response) {
      if (!response.ok) throw new Error('Vehicle data request failed');
      return response.json();
    }).then(function (data) {
      if (version !== dataVersion) return getState();
      if (!Array.isArray(data) || !data.length) throw new Error('Vehicle data unavailable');
      rows = data.filter(function (row) { return row && row.Year && row.Make && row.Model; }).map(function (row) {
        var next = {};
        ['Year', 'Make', 'Model', 'Position', 'Note', 'PartNumber'].forEach(function (key) { next[key] = text(row[key]); });
        return next;
      });
      if (!rows.length) throw new Error('Vehicle data unavailable');
      loaded = true;
      loading = false;
      invalidateOptions();
      validateRestoredState();
      persist();
      emit();
      return getState();
    }).catch(function () {
      if (version !== dataVersion) return getState();
      loading = false;
      error = 'load_error';
      emit();
      return getState();
    }).finally(function () { clearTimeout(timeout); });
  }
  function load() {
    if (loaded || loading) return dataPromise;
    dataPromise = loadData();
    return dataPromise;
  }
  function retry() { dataPromise = loadData(); return dataPromise; }
  function submit(resultPage) {
    if (submitPromise) return submitPromise;
    var selectedAtSubmit = JSON.stringify(copySelection(selection));
    var saved = boot.matchSaved(selection, vehicles, false);
    var cached = saved && contextMatchesSelection(saved.resultContext, selection) ? saved.resultContext : '';
    submitting = true;
    emit();
    submitPromise = Promise.resolve(cached ? null : load()).then(function () {
      if (JSON.stringify(copySelection(selection)) !== selectedAtSubmit) throw new Error(messageText('selectVehicleText'));
      if (!cached && !isComplete()) throw new Error(messageText(error ? 'errorText' : 'selectVehicleText'));
      var vehicle = cached;
      if (!vehicle) {
        var matching = rows.filter(function (row) {
          return prefixMatches(row, selection, 3) && (!selection.position || row.Position === selection.position || positionLabel(row) === selection.position);
        });
        var parts = Array.from(new Set(matching.map(function (row) { return row.PartNumber; }))).join(',');
        vehicle = [selection.year, selection.make, selection.model].join('@') + (selection.position ? '@' + selection.position : '') + '@@' + parts;
      }
      var form = document.querySelector('[data-vehicle-form][data-result-page]');
      var url = new URL(resultPage || (form && form.dataset.resultPage) || '/collections/all_pdt', location.origin);
      if (url.origin !== location.origin) throw new Error('Vehicle result page must belong to this store.');
      url.searchParams.set('view', 'search_result');
      // The context travels with the document request, so Liquid can render the
      // matching products and bulb title without a preceding cart mutation.
      url.searchParams.set('sort_by', vehicle);
      url.searchParams.set('vehicle', vehicle);
      url.searchParams.set('vehicle_sort', 'manual');
      url.searchParams.delete('page');
      url.searchParams.delete('vehicle_page');
      resultContext = vehicle;
      saved = boot.matchSaved(selection, vehicles, false);
      if (saved) saved.resultContext = vehicle;
      persist();
      var results = window.LuxsterVehicleResults;
      if (results && results.canNavigate(url.href)) {
        // Keep the shared vehicle data and global navigation alive. The results
        // controller owns fitment requests, history, retry and stale responses.
        document.dispatchEvent(new CustomEvent('luxster:vehicle:navigate', { detail: { url: url.href } }));
        return results.navigate(url.href).then(function (outcome) {
          if (outcome && outcome.superseded) return null;
          if (!outcome || !outcome.ok) throw (outcome && outcome.error) || new Error(messageText('errorText'));
          return url.href;
        }).finally(function () {
          submitting = false;
          submitPromise = null;
          emit();
        });
      }
      location.assign(url.href);
      return url.href;
    }).catch(function (submitError) {
      submitting = false;
      submitPromise = null;
      emit();
      throw submitError;
    });
    return submitPromise;
  }

  restore();
  window.LuxsterVehicle = {
    get ready() { return dataPromise; }, getState: getState, getOptions: getOptions,
    subscribe: function (listener) { listeners.add(listener); listener(getState()); return function () { listeners.delete(listener); }; },
    select: select, activate: activate, add: add, remove: remove, clear: clear, submit: submit, load: load, retry: retry,
    syncResultContext: syncResultContext
  };
  document.addEventListener('change', function (event) {
    var control = event.target.closest('[data-vehicle-field]');
    if (control && control.closest('[data-vehicle-form]')) select(control.dataset.vehicleField, control.value);
  });
  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-vehicle-form]');
    if (!form) return;
    event.preventDefault();
    formMessages.delete(form);
    submit(form.dataset.resultPage).catch(function (submitError) { formMessages.set(form, submitError.message); renderForms(); });
  });
  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-vehicle-retry]')) { event.preventDefault(); retry(); }
  });
  document.addEventListener('shopify:section:load', function () {
    if (document.querySelector('[pdt_search][data-vehicle-form]')) load();
    renderForms();
  });
  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    submitting = false;
    submitPromise = null;
    try {
      var stored = localStorage.getItem(STORAGE_KEY);
      if (stored === null) {
        selection = emptySelection();
        vehicles = [];
        activeId = null;
        invalidateOptions();
      } else readStored(stored);
    } catch (storageError) { /* Keep the page's current state if storage is inaccessible. */ }
    var context = currentResultContext();
    if (context.isResults && !context.isBulb) applyResultContext(context.vehicle);
    if (loaded) validateRestoredState();
    if (context.isResults && !context.isBulb) persist();
    formMessages = new WeakMap();
    emit();
  });
  window.addEventListener('storage', function (event) {
    if (event.key !== STORAGE_KEY) return;
    if (event.newValue === null) { selection = emptySelection(); vehicles = []; activeId = null; invalidateOptions(); }
    else if (!readStored(event.newValue)) return;
    ++stateRevision;
    pendingResultContext = false;
    resultContext = '';
    if (loaded) validateRestoredState();
    formMessages = new WeakMap();
    emit();
  });
  dataPromise = Promise.resolve(getState());
  if (document.querySelector('[pdt_search][data-vehicle-form]')) load();
  else renderForms();
}());
